export const REA = 'real-estate-agents'
export const LO = 'loan-officers'

export const LEGACY_REA = 'realestate'
